import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@/context/auth-context';
import { AuthLoading } from '@/components/auth/auth-loading';

interface Props {
  children: React.ReactNode;
}

/** Gate authenticated app routes behind terms acceptance (and PWZ when required). */
export function RequireOnboarded({ children }: Props) {
  const { user, loading, profileLoading, needsOnboarding } = useAuth();
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}`;

  if (loading || (user && profileLoading)) {
    return <AuthLoading />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: returnTo }} />;
  }

  if (needsOnboarding) {
    return <Navigate to="/onboarding" replace state={{ from: returnTo }} />;
  }

  return <>{children}</>;
}
